// extracted by mini-css-extract-plugin
export default {"fr-view":"FormattedText_fr-view__gRo3i","container":"FormattedText_container__aV9ck"};